import { configureStore } from '@reduxjs/toolkit';
import routesReducer from './slices/routesSlice';
import vehiclesReducer from './slices/vehiclesSlice';
import driversReducer from './slices/driversSlice';
import uiReducer from './slices/uiSlice';
import locationsReducer from './slices/locationsSlice';
import tollsReducer from './slices/tollsSlice';
import fuelPricesReducer from './slices/fuelPricesSlice';
import statsReducer from './slices/statsSlice';
import transportOrdersReducer from './slices/transportOrdersSlice';
import vrpReducer from './slices/vrpSlice';
import notificationsReducer from './slices/notificationsSlice';

const store = configureStore({
  reducer: {
    routes: routesReducer,
    vehicles: vehiclesReducer,
    drivers: driversReducer,
    ui: uiReducer,
    locations: locationsReducer,
    tolls: tollsReducer,
    fuelPrices: fuelPricesReducer,
    stats: statsReducer,
    transportOrders: transportOrdersReducer,
    vrp: vrpReducer,
    notifications: notificationsReducer,
  },
});

export default store;
